<template>
    <div class="stream-retry-modal" @focusin="onFocus" @focusout="onFocusout" @click.prevent>
        <div class="stream-retry-modal__wrapper">
            <div class="stream-retry-modal__title">{{ title }}</div>
            <div class="stream-retry-modal__button-container">
                <button
                    id="stream-retry-btn"
                    ref="btnTryRef"
                    class="stream-retry-modal__btn btn"
                    data-type="modal-button"
                    data-keyright="stream-cancel-btn"
                    :disabled="loading"
                    @click="onClick"
                >
                    <loader v-if="loading" class="stream-retry-modal__loader" />
                    <span v-else>{{ buttonTry }}</span>
                </button>
                <button
                    id="stream-cancel-btn"
                    class="stream-retry-modal__btn btn"
                    data-type="modal-button"
                    data-keyleft="stream-retry-btn"
                    @click="closeModal"
                >
                    {{ buttonCancel }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { watch, nextTick } from "vue";
    import { Strings } from "@/locales/types/enums/strings";
    import { useOnline } from '@vueuse/core'
    import { useI18n } from "vue-i18n";
    import { onMounted, onBeforeUnmount, type Ref, ref } from "vue";

    const props = defineProps({
        loading: {
            type: Boolean,
            required: true
        }
    });
    const emit = defineEmits(['on-btn-click', 'close'])
    const { t } = useI18n();
    const { $navigator } = useNuxtApp();
    const btnTryRef: Ref<HTMLButtonElement | null> = ref(null);
    const title: string = t(Strings.PLAYER_RETRY_MODAL_MESSAGE).toString();
    const buttonTry: string = t(Strings.PLAYER_RETRY_MODAL_TRY_BUTTON).toString();
    const buttonCancel: string = t(Strings.PLAYER_RETRY_MODAL_CANCEL_BUTTON).toString();
    const onClick = () => {
        emit("on-btn-click");
    };
    const onFocus = () => {
        registerKeyListeners();
    };
    const onFocusout = () => {
        unregisterKeyListeners();
    };
    const registerKeyListeners = () => {
        $navigator.on("keypress:back", closeModal);
    };
    const unregisterKeyListeners = () => {
        $navigator.off("keypress:back", closeModal);
    };
    const closeModal = () => {
        if (!useOnline().value) {
            return;
        }
        emit('close')
    }
    const focusOnBtn = () => {
        void nextTick(() => {
            btnTryRef.value?.focus();
        })
    };
    onMounted(() => { 
        $navigator.disableDownButton();
        focusOnBtn();
    });
    onBeforeUnmount(() => {
        $navigator.enableDownButton();
    });
    watch(
        () => props.loading,
        (val) => {
            if (!val) {
                focusOnBtn();
            }
        }
    )
</script>

<style lang="scss">
    @import url("styles.scss");
</style>
